export const CustomLeftArrow = () => {
  return <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    {/* Heart shape behind arrow */}
    <path d="M12 21c-1.5-1.6-9-5.8-9-12.1C3 5.6 5.5 3 8.5 3c1.7 0 3.3.8 4.3 2.2.5.7.5 1.7 0 2.4" fill="rgba(255, 107, 107, 0.1)" stroke="rgba(255, 107, 107, 0.8)" strokeWidth="1.5" />
    <path d="M12 21c1.5-1.6 9-5.8 9-12.1 0-3.3-2.5-5.9-5.5-5.9-1.7 0-3.3.8-4.3 2.2-.5.7-.5 1.7 0 2.4" fill="rgba(255, 107, 107, 0.1)" stroke="rgba(255, 107, 107, 0.8)" strokeWidth="1.5" />
    {/* Arrow */}
    <path d="M16 12H8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M11 9L8 12L11 15" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
};
  
